import HomeHeader from '../../components/home/header/HomeHeader'
 import AboutPageComponent from '../../components/about/AboutPageComponent'
import HomeFooter from '../../components/home/footer/HomeFooter'
import './AboutPage.css'

const AboutPage = () => {
  return (
    <div>
      <div className='header-container'>
        <HomeHeader isHeaderLeft={true} showLoginButton={true} showSignupButton={true}/>
      </div>
      <div>
        {/* put inside the about page here */}
        <AboutPageComponent/>
      </div>
      <div style={{ background: 'black', color: 'white' }}>
        <HomeFooter />
      </div>
    </div>
  );
}

export default AboutPage;